export default {
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. photo slideshow',
  assets_domains: {
    item_thumbnail: 'thumb-vh.s3.envato.com',
    item_image: 'image-vh.s3.envato.com'
  },
  feeds_categories: [
    '/category/after-effects-project-files',
    '/category/premiere-pro-templates',
    '/category/apple-motion-templates',
    '/category/motion-graphics',
    '/category/stock-footage',
    '/category/cinema-4d-templates',
    '/category/add-ons'
  ],
  features: {
    'transition-to-new-design': true,
    'experiments:loading-cover': false
  }
}
